// This module provides API call methods for Sephora Commerce Basket APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Basket+APIs


const getSamples = require('./getSamples');
const getBasketDetails = require('./getBasketDetails');
const addToCart = require('./addToCart');
const applyPromotion = require('./applyPromotion');
const updateBasket = require('./updateBasket');
const addSamplesToBasket = require('./addSamplesToBasket');
const addMsgPromotionToBasket = require('./addMsgPromotionToBasket');
const removePromotion = require('./removePromotion');
const removeSkuFromBasket = require('./removeSkuFromBasket');
const switchBasketItem = require('./switchBasketItem');

module.exports = {
    getSamples,
    getBasketDetails,
    addToCart,
    applyPromotion,
    updateBasket,
    addSamplesToBasket,
    addMsgPromotionToBasket,
    removePromotion,
    removeSkuFromBasket,
    switchBasketItem
};
